import { ProviderJobLayout } from "@/features/jobs/provider-job-layout";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_provider/provider/jobs")({
  component: () => {
    return (
      <ProviderJobLayout>
        <Outlet />
      </ProviderJobLayout>
    );
  },
});
